import * as Sentry from '@sentry/browser';
import * as moment from 'moment';
import { assign } from 'lodash';
import * as Cookies from 'js-cookie';
import * as actions from '../constants';

declare var process: any;

const APP_COOKIE = process.env.APP_COOKIE || 'my-auth-cookie';

const initialState: any = {
  isFetching: false,
  isAuthenticated: false,
  isGlobalAdmin: false,
  didInvalidate: false,
  error: false,
  user: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.SWITCH_ACCOUNT: {
      const user = state.user;
      user.accounts.forEach(
        (account) =>
          (account.user_account.is_default = action.id === account.id),
      );
      const localData = Cookies.getJSON(APP_COOKIE);
      // Update the default account in the cookies and then reload page
      localData.user.accounts = user.accounts;
      Cookies.set(APP_COOKIE, localData);
      window.location.reload();
      return state;
    }

    case actions.REQUEST_LOGIN:
      return assign({}, state, {
        isFetching: true,
        error: false,
      });

    case actions.REJECT_LOGIN:
      return assign({}, state, {
        isFetching: false,
        isAuthenticated: false,
        didInvalidate: true,
        error: action.error,
      });

    case actions.RECEIVE_LOGIN: {
      Sentry.configureScope((scope) => {
        scope.setTag('version', process.env.VERSION);
        scope.setUser(action.data.user);
      });
      return assign({}, state, {
        isFetching: false,
        isAuthenticated: action.error === false,
        didInvalidate: action.error !== false,
        isGlobalAdmin: Boolean(
          action.error === false && action.data.user && action.data.user.admin,
        ),
        error: action.error,
        user:
          action.error === false && action.data.user ? action.data.user : false,
      });
    }

    case actions.CHECK_LIFETIME: {
      const localData = Cookies.getJSON(APP_COOKIE);
      const daysOld = moment().diff(moment(localData.date), 'days');
      const hoursOld = moment().diff(moment(localData.date), 'hours');

      // If the local data is older than a day reset default site
      // else use the stored one
      if (daysOld > 0) {
        localData.date = new Date();
        localData.user.accounts = action.data.user.accounts;
        Cookies.set(APP_COOKIE, localData);
      } else if (hoursOld > 3) {
        // When it has not expired, if the time is greater than 3 hours
        // refresh the date stored
        localData.date = new Date();
        Cookies.set(APP_COOKIE, localData);
      }
      return assign({}, state, {
        user: localData.user,
      });
    }

    case actions.LOGOUT:
      return assign({}, initialState);

    default:
      return state;
  }
};
